import { render, staticRenderFns } from "./CompanyInventoryArchivedPage.vue?vue&type=template&id=fba4c616&scoped=true&"
import script from "./CompanyInventoryArchivedPage.vue?vue&type=script&lang=js&"
export * from "./CompanyInventoryArchivedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba4c616",
  null
  
)

export default component.exports